import React from 'react';
import { motion } from 'framer-motion';
import { SectionMarker } from './SectionMarker';
import { CheckItem } from './CheckItem';
import { CTAButton } from './CTAButton';
export function FinalOfferSection() {
  const includes = ['Ebook completo', 'Método estructurado de 21 noches', 'Plantillas listas para usar', 'Calendario imprimible', 'Protocolo específico para despertares nocturnos'];
  return <section className="w-full bg-navy-dark py-10 md:py-14" data-id="element-67">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8" data-id="element-69">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-70">
            <SectionMarker data-id="element-71" />
            <span className="text-cream-muted text-sm uppercase tracking-wider" data-id="element-72">
              Oferta final
            </span>
          </div>
        </motion.div>

        {/* Centered clean mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-12" data-id="element-73">
          <img src="https://cdn.magicpatterns.com/uploads/6EJNjg7LBcVSCw3DK8rpgd/hf_20260218_150731_eea4a4a8-a8c8-4237-9c5d-9a35a8501130.png" alt="Método de 21 Noches — vista en tablet y celular" className="w-full max-w-md object-contain" data-id="element-74" />
        </motion.div>

        {/* Content centered */}
        <div className="max-w-xl mx-auto" data-id="element-75">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="font-playfair text-2xl md:text-3xl font-bold text-cream mb-8 text-center" data-id="element-76">
            Incluye:
          </motion.h2>

          <div className="space-y-5 mb-10" data-id="element-77">
            {includes.map((item, index) => <CheckItem key={item} delay={0.1 * index} data-id="element-78">
                {item}
              </CheckItem>)}
          </div>

          {/* Price & Final CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="text-center py-8 border-t border-cream-muted/10" data-id="element-79">
            <p className="text-lg text-cream-muted mb-2" data-id="element-80">
              Precio total del programa:{' '}
              <span className="line-through" data-id="element-81">$37.00</span>
            </p>
            <p className="font-playfair text-2xl md:text-3xl font-bold text-cream mb-6" data-id="element-82">
              Hoy puedes acceder por solo
            </p>

            {/* Price circle */}
            <div className="flex flex-col items-center mb-6" data-id="element-83">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-full border-2 border-amber bg-navy-darkest/80 flex flex-col items-center justify-center shadow-lg shadow-amber/10" data-id="element-84">
                <span className="font-playfair text-4xl md:text-5xl font-bold text-amber leading-none" data-id="element-85">
                  $17
                </span>
                <span className="text-cream text-sm md:text-base font-medium mt-1" data-id="element-86">
                  USD
                </span>
              </div>
              <span className="mt-3 text-xs md:text-sm uppercase tracking-widest text-amber/80 font-semibold animate-pulse" data-id="element-87">
                ⏳ Por tiempo limitado
              </span>
            </div>

            <div className="space-y-3 inline-block text-left mb-6" data-id="element-88">
              <p className="flex items-center gap-2 text-cream" data-id="element-89">
                <span className="text-teal-check" data-id="element-90">✔</span> Acceso inmediato
              </p>
              <p className="flex items-center gap-2 text-cream" data-id="element-91">
                <span className="text-teal-check" data-id="element-92">✔</span> Formato digital
              </p>
              <p className="flex items-center gap-2 text-cream" data-id="element-93">
                <span className="text-teal-check" data-id="element-94">✔</span> Empieza esta misma
                noche
              </p>
            </div>

            <p className="text-cream-muted text-base mt-4 leading-relaxed" data-id="element-95">
              Menos que una caja de melatonina. Menos que una semana acumulando
              café por cansancio.
            </p>

            <p className="text-cream text-lg mt-4" data-id="element-96">
              Pero con un protocolo que puedes usar todas las noches.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.7
        }} className="text-center pt-6 pb-2 space-y-4" data-id="element-97">
            <p className="font-playfair text-xl md:text-2xl font-bold text-cream" data-id="element-98">
              No necesitas dormir perfecto.
            </p>
            <p className="font-playfair text-xl md:text-2xl italic text-amber" data-id="element-99">
              Necesitas empezar a regular.
            </p>

            <div className="pt-4" data-id="element-100">
              <CTAButton className="w-full sm:w-auto text-base md:text-lg px-10 py-5" data-id="element-101">
                QUIERO DORMIR SIN DESPERTARME
              </CTAButton>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}